import React, { useState } from "react";
import EditCalendarData from "./EditCalendarData";
import EditCalendarConfig from "./EditCalendarConfig";
import EditCalendarFilter from "./EditCalendarFilter";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

const EditCalendar = ({ tableRef, setIsEditBarOpen, currentSmLookup, tableId, tableType }) => {
  const [selectedTab, setSelectedTab] = useState("data");

  return (
    <div className="sidebarView_edit_outer edit_open">
      <div className="sidebar_top_header">
        <span>Edit Calender</span>
        <MaterialIcon name="close" className="section_close_darkIcon" onClick={() => setIsEditBarOpen(false)} />
      </div>
      <div className="sidebar_tab_buttons mediumtab">
        {["data", "filters", "config"].map((name) => (
          <div
            key={name}
            className={`sidebar_tabs ${selectedTab === name && "active"}`}
            onClick={() => setSelectedTab(name)}
          >
            {name}
          </div>
        ))}
      </div>
      {selectedTab === "data" && <EditCalendarData tableRef={tableRef} />}
      {selectedTab === "config" && <EditCalendarConfig tableRef={tableRef} />}
      {selectedTab === "filters" && (
        <EditCalendarFilter
          tableRef={tableRef}
          currentSmLookup={currentSmLookup}
          tableType={tableType}
          tableId={tableId}
        />
      )}
    </div>
  );
};

export default EditCalendar;
